module.exports = __webpack_public_path__ + "img/mail-01.25bd89cc.svg";